<template>

  <div id="directors" class="section">
    <div class="directors_wrap">
      <div class="directors_inside">
        <div class="directors_text">
          <h1>Director's Statement</h1>
          <p>
          この10年、私はドキュメンタリー映画を作ってきました。
          私自身がカメラを構えて、現実を見つめつづけてきました。<br class="norm_br">
          それが新型コロナウイルスが蔓延し、行動が制限され、交流が自粛され、
          人と人との距離も離れていき、<br class="norm_br">
          マスク越しの顔ばかりが並ぶ日常が到来した現在。<br class="norm_br">
          私はいまこそフィクションの力によって、
          この現実と向き合うべきなのだと覚悟しました。<br class="norm_br"><br><br>
          本作は映画を作る男と、その男を支える女のラブストーリーです。
          いわば私自身の物語です。<br class="norm_br">
          いまこの私がフィクションを撮るのなら、私自身のドキュメンタリーとして撮るべき以外の道はありませんでした。<br class="norm_br">
          私と馴染み深い東京の街並みや、実際に私が住む部屋を舞台として、私自身の生活を惜しみなく投入することで、<br class="norm_br">
          安易な自己愛に陥ることなく、この現代日本社会で、一個人の立場から映画を作るというその営みの尊さを、<br class="norm_br">
          どこまで切実に描ききれるか・・・<br class="norm_br">
          <br><br>
          本作は、近年作り続けてきたドキュメンタリー映画と変わらない創作態度によって、生活に根ざし、人間たちに肉薄した、<br class="norm_br">
          映画の新たな<ruby>象<rt>かたち</rt></ruby>を追究した劇映画です。
          
          </p>
          <div class="director_content">
          <div class="director_photo"></div>
          <div class="director_profile">
            <h3 class="title">監督</h3>
            <h2 class="name">堀江 実</h2>
            <p class="director_profile">
            1980年生まれ、東京都出身。<br class="norm_br">
            長谷川和彦と柳町光男、両監督の薫陶を受け映画制作を開始。
            近年はドキュメンタリー映画を立て続けに発表している。
            代表作に『みずち』(13)、『首くくり栲象の庭』(16)など。
            </p>  

          </div>
          </div>
          </div>

      </div> <!-- indide-->
      
    </div> <!--wrap-->


  </div>

</template>


<style>

  #directors{
  display: flex; 
  flex-direction: column;
  
  /* border: 1px dashed rgb(1, 60, 10);  */
  color: rgb(0, 0, 0);
  font-family: 'Shippori Mincho', sans-serif;
  width:100%;
  height:auto;

}
.directors_wrap{
  /* border: 5px dashed rgb(124, 0, 233);  */
  position: relative;
  display: flex;
  width: auto;
  align-items: center;
  padding-top: 10vh;
  justify-content: center; /* 水平方向の中央揃え */

}
.directors_inside{
  /* border: 1px solid rgb(70, 0, 233); */
  display: flex;
  width: auto;
  height: auto;
  margin-top: 5vh;
  justify-content: center;
}



.directors_text{
  /* border: 1px dashed rgb(233, 0, 0);  */
  width:auto;
  width:80vw;
  height:auto;
  text-align: justify;

}

.directors_text h1{
  /* border: 1px dashed rgb(233, 0, 0);  */
  line-height: 1;
  white-space: nowrap;
  letter-spacing: 0.1px; 
  /* text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3); */
  font-weight: bolder;
  padding-left:0;
  font-size:calc(32px);
  margin-left: 0vw;
  margin-right: 0vw;
 
}

.directors_text p{
  /* border: 1px dashed rgb(233, 0, 0);  */
  padding-left: 0;
  Width:auto;
  font-size: calc(14px);
  line-height: 1.8;
  letter-spacing: 2px; 
  margin-left: 0vw;
  margin-right: 0vw;
  margin-bottom: 5vh;
}

.norm_br{
  display: block;
}

.director_content{
  /* border: 1px solid rgb(13, 0, 255); */
  display:block;
  align-items: top;
  margin-top: 2vw;
  margin-bottom: 3vw;
  padding-left: 0;
  width: auto;
  height: auto;;
  text-align: justify;
}

.director_photo{
  /* border: 4px solid rgb(0, 255, 208); */
  background-image: url('../assets/Director2.jpg');
  background-size:contain;
  background-repeat: no-repeat;
  background-position: left;
  width: 291px;
  height:193px;
  
  min-height: 193px;
  min-width: 291px;
}

.director_profile{
  /* border: 1px solid rgb(255, 183, 0);  */
  
  padding-top: 1vh;
  padding-left: 0;
  padding-right:0;
  Width:30vw;
  height:auto;
  min-width: 291px;
  font-size: calc(14px);
}

p.director_profile{
  font-family: 'Shippori Mincho', sans-serif;
  /* font-family: 'Zen Kaku Gothic New', sans-serif; */
  /* border: 1px solid rgb(13, 0, 255);  */
  /* color: blueviolet; */
  width: auto;
  height: auto;
  line-height: 1.6;
  margin-top: 5px;
  padding-top: 0;

}

.director_profile h1{

/* border: 1px solid rgb(234, 10, 51);  */
font-family: 'Zen Kaku Gothic New', sans-serif;
font-size: 32px;

}

.director_profile h2,h3{

  /* border: 1px solid rgb(234, 10, 51);  */
  font-family: 'Zen Kaku Gothic New', sans-serif;

  margin-top: 15px;

  margin-bottom: 0;
  
}

.director_profile .title, .director_profile .name {
  display: inline-block;
  margin-right: 5px;
}

.director_profile .title {
  
  letter-spacing:0px;
  padding-left: 0;
}

.director_profile .name {
  
  font-weight:bolder;
  letter-spacing:0px;
  padding-left: 1vw;;
}





@media (min-width: 200px) {
  .directors_inside{
  /* border: 2px dashed rgb(0, 233, 155); */
  display: flex;
  width: auto;
  height: auto;
  margin-left: 0vw;
  margin-right: 0vw;
  margin-bottom: 5vh;
}

.directors_text h1{
  font-size: 24px;
}

.director_content{
  /* border: 1px solid rgb(13, 0, 255); */
  display:block;
  align-items: top;
  margin-top: 2vw;
  margin-bottom: 3vw;
  padding-left: 0;
  width: auto;
  height: auto;;
  text-align: justify;
}

.director_photo{
  /* border: 4px solid rgb(255, 0, 89); */
  background-image: url('../assets/Director2.jpg');
  background-size:contain;
  background-repeat: no-repeat;
  background-position: left;
  width: 232px;
  height:154px;
  
  min-height: 232px;
  min-width: 154px;
}

.director_profile{
  /* border: 2px solid rgb(255, 183, 0);  */
  
  padding-top: 1vh;
  padding-left: 0;
  padding-right:0;
  Width:232px;
  height:auto;
  min-width: 232px;
  font-size: calc(14px);
}
p.director_profile{
  font-family: 'Shippori Mincho', sans-serif;
  /* font-family: 'Zen Kaku Gothic New', sans-serif; */
  /* border: 1px solid rgb(13, 0, 255);  */
  /* color: blueviolet; */
  width: auto;
  height: auto;
  line-height: 1.6;
  margin-top: 5px;
  padding-top: 0;

}
}


@media screen and (min-width:380px){
 .norm_br{
  display: none;
  }

  .directors_text h1{
  font-size: 30px;
}

.director_photo{
  /* border: 4px solid rgb(8, 0, 255); */
  background-image: url('../assets/Director2.jpg');
  background-size:contain;
  background-repeat: no-repeat;
  background-position: left;
  width: 291px;
  height:193px;
  
  min-height: 193px;
  min-width: 291px;
}
.director_profile{
  /* border: 1px solid rgb(111, 0, 255);  */
  
  padding-top: 1vh;
  padding-left: 0;
  padding-right:0;
  Width:30vw;
  height:auto;
  min-width: 291px;
  font-size: calc(14px);
}

}


@media (min-width: 630px) {

  .directors_inside{
  /* border: 4px dashed rgb(233, 0, 43); */
  display: flex;
  width: 80vw;
  height: auto;
  }

  .directors_text h1{
  font-size: 32px;
  }

  .director_profile{
  /* border: 2px dashed rgb(233, 0, 31); */
  min-width: 291px;
}


}





@media (min-width: 1024px) {
  .directors_inside{
  /* border: 2px dashed rgb(0, 233, 155); */
  display: flex;
  width: auto;
  height: auto;
}

.directors_text{
  /* border: 1px dashed rgb(233, 0, 0);  */
  width:auto;
  /* width:90vw; */
  height:auto;
  text-align: justify;

}



.director_profile{
  /* border: 2px dashed rgb(233, 0, 31); */
  min-width: 291px;
  max-width: 291px;
}

}





</style>